import { render, staticRenderFns } from "./TrendDecoration.vue?vue&type=template&id=4bbd6362&name=trend-decoration&"
import script from "./TrendDecoration.vue?vue&type=script&lang=js&"
export * from "./TrendDecoration.vue?vue&type=script&lang=js&"
import style0 from "./TrendDecoration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports